import { GovDropdown, GovIcon } from '@gov-design-system-ce/react';
import { useBoolean } from '@gov-nx/utils/common';
import { Button } from '../Button/Button';
import { DocumentDownloadItem } from '../DocumentDownload/DocumentDownloadItem';

interface AttachmentProps {
	name?: string;
	size?: number;
	onDownload: (onSuccess: () => void) => void;
	downloadLabel: string;
}

export const Attachment = ({
	size,
	name,
	downloadLabel,
	onDownload,
}: AttachmentProps) => {
	const isLoading = useBoolean();
	const isDropdownOpen = useBoolean();

	return (
		<li className="w-full [ sm:w-auto ]">
			<GovDropdown
				open={isDropdownOpen.value}
				position="right"
				color="primary"
				type="base"
				size="s"
				expandedMobile
				aria-label={name}
				className="document-download"
				label={
					<DocumentDownloadItem
						name={name}
						size={size}
					/>
				}>
				<Button
					onClick={() => {
						isLoading.setTrue();
						onDownload(() => {
							isLoading.setFalse();
							isDropdownOpen.setFalse();
						});
					}}
					color="neutral"
					type="base"
					size="s"
					isLoading={isLoading.value}
					isDisabled={isLoading.value}
					aria-label={downloadLabel}>
					{downloadLabel}
					<GovIcon
						name="download"
						type="templates"
					/>
				</Button>
			</GovDropdown>
		</li>
	);
};
